export const DEFAULT_PROFILE_IMG = "https://res.cloudinary.com/dnu4ciook/image/upload/v1653229201/profile1_xjv2nc.png"
/** Iconos fijos de redes en la lista de enlaces (public/); no se usa miniImage del API */
export const DEFAULT_FACEBOOK_LINK_IMAGE = `${process.env.PUBLIC_URL ?? ""}/images/facebook-link-default.svg`
export const DEFAULT_INSTAGRAM_LINK_IMAGE = `${process.env.PUBLIC_URL ?? ""}/images/instagram-link-default.svg`
export const DEFAULT_TWITTER_LINK_IMAGE = `${process.env.PUBLIC_URL ?? ""}/images/twitter-link-default.svg`
export const DEFAULT_TIKTOK_LINK_IMAGE = `${process.env.PUBLIC_URL ?? ""}/images/tiktok-link-default.svg`
export const DEFAULT_WEBSITE_LINK_IMAGE = `${process.env.PUBLIC_URL ?? ""}/images/website-link-default.svg`
export const DEFAULT_BACKGROUND_COLOR = "black";
export const DEFAULT_TEXT_COLOR = "white";
export const DEFAULT_BUTTONS_TEXT_COLOR = "black";
export const DEFAULT_BUTTONS_COLOR = "white";
export const DEFAULT_BUTTONS_BODER_COLOR = "transparent";